module.exports = __webpack_public_path__ + "static/media/pins_alert.64d0a4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/pins_alert.png
// module id = 1124
// module chunks = 0